import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type Quiz = {
    id: number
    webinar: any
    questions: any[]
}

export type QuizDto = {
    webinar: number
    questions: number[]
}

export const quizApi = createApi({
    reducerPath: 'quizApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["QUIZ"],
    endpoints: builder => ({
        getAllQuiz: builder.query<Quiz[], void>({
            query: () => ({ url: `/quiz` }),
            providesTags: ["QUIZ"]
        }),
        getAllQuizEn: builder.query<Quiz[], void>({
            query: () => ({ url: `/quiz?lang=en` }),
            providesTags: ["QUIZ"]
        }),
        getQuiz: builder.query<Quiz, { id: number }>({
            query: ({ id }) => ({ url: `/quiz/${id}` }),
            extraOptions: {includeToken: false},
            providesTags: ["QUIZ"]
        }),
        createQuiz: builder.mutation<any, QuizDto>({
            query: data => ({ url: `/quiz`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUIZ"]
        }),
        deleteQuizByIds: builder.mutation<any, any>({
            query: data => ({ url: `/quiz/delete-by-ids`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUIZ"]
        }),
        updateQuiz: builder.mutation<any, any>({
            query: data => {
                let body = {...data}
                delete body.id
                return { url: `/quiz/${data.id}`, method: 'PATCH', body: body }
            },
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUIZ"]
        }),
        updateQuizEn: builder.mutation<any, any>({
            query: data => ({ url: `/quiz/en/update/${data.id}`, method: 'PATCH', body: {name: data.name, post: data.post} }),
            invalidatesTags: ["QUIZ"]
        }),
        getQuizResults: builder.mutation<any, {id : number}>({
            query: data => {
                let url = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/quiz/quiz-answers/${data.id}`
                
                return { url: url, method: 'GET' }
            },
            invalidatesTags: ['QUIZ']
        }),
    })
})

export const {
    useGetAllQuizQuery,
    useGetAllQuizEnQuery,
    useGetQuizQuery,
    useCreateQuizMutation,
    useDeleteQuizByIdsMutation,
    useUpdateQuizMutation,
    useUpdateQuizEnMutation,
    useGetQuizResultsMutation
} = quizApi
